module.exports = __webpack_public_path__ + "static/media/file-import.40bffe7b.svg";